import { createSelector } from "@reduxjs/toolkit";
import { AUTHOR_TYPES } from "../../../packages/constants";
import { helpers } from "../../../packages/helpers";
import { selectChatMessages } from "./select-chat-messages";
import { selectAuthorList } from "./select-author-list";

const { getStringValue } = helpers.text;

export const selectLastMessageRole = createSelector(
  selectChatMessages,
  selectAuthorList,
  (messages, authors) => {
    const authorId = getStringValue(messages.slice(-1)[0]?.authorId);

    return authors[authorId]?.role || AUTHOR_TYPES.BOT;
  }
);
